import { gsap } from "gsap";

export const init = () => {
  const containers = document.querySelectorAll(".logoinmove");

  containers.forEach((logo) => {
    const container = logo.closest(".anim-trigger");
    if (!container) return;

    // 1. Forzar estilos críticos para garantizar sistema de coordenadas correcto y Z-index
    // position: absolute, top:0, left:0 asegura que (0,0) sea la esquina superior izquierda
    // z-index: -1 lo manda al fondo
    // pointer-events: none evita que bloquee clics
    gsap.set(logo, {
      position: "absolute",
      top: 0,
      left: 0,
      margin: 0,
      pointerEvents: "none",
      x: 0,
      y: 0
    });

    // Aseguramos que el contenedor tenga posición relativa para ser el referente
    // Nota: Es mejor si esto está en CSS, pero lo forzamos por seguridad
    const containerStyle = window.getComputedStyle(container);
    if (containerStyle.position === 'static') {
        container.style.position = 'relative';
    }

    // Variables de estado
    let x = 0;
    let y = 0;

    // Posición inicial aleatoria dentro de los límites seguros
    // Esperamos un tick para asegurar que el DOM tenga dimensiones correctas
    requestAnimationFrame(() => {
        const cw = container.clientWidth;
        const ch = container.clientHeight;
        const lw = logo.offsetWidth;
        const lh = logo.offsetHeight;

        if (cw > lw) x = Math.random() * (cw - lw);
        if (ch > lh) y = Math.random() * (ch - lh);

        gsap.set(logo, { x, y });
    });

    // Velocidad
    const speed = logo.dataset.animspeed || 1.5;
    let vx = speed * (Math.random() < 0.5 ? 1 : -1);
    let vy = speed * (Math.random() < 0.5 ? 1 : -1);

    // Visibilidad
    let isVisible = true;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isVisible = entry.isIntersecting;
      });
    });
    observer.observe(container);

    const update = () => {
        if (!isVisible) return;

        // Usar clientWidth/Height para excluir bordes del contenedor
        // Esto es más preciso para "dentro" de la caja visual
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        const logoWidth = logo.offsetWidth;
        const logoHeight = logo.offsetHeight;

        const maxX = containerWidth - logoWidth;
        const maxY = containerHeight - logoHeight;

        // Si no cabe, no mover o centrar
        if (maxX <= 0 || maxY <= 0) return;

        // Actualizar posición
        x += vx;
        y += vy;

        // Colisiones con "rebote" simple
        // Si se pasa, lo colocamos en el borde y revertimos velocidad
        if (x >= maxX) {
            x = maxX;
            vx = -Math.abs(vx); // Asegurar dirección negativa
        } else if (x <= 0) {
            x = 0;
            vx = Math.abs(vx); // Asegurar dirección positiva
        }

        if (y >= maxY) {
            y = maxY;
            vy = -Math.abs(vy);
        } else if (y <= 0) {
            y = 0;
            vy = Math.abs(vy);
        }

        // Aplicar
        gsap.set(logo, { x: x, y: y, force3D: true });
    };

    gsap.ticker.add(update);
  });
};
